export const DDC_MAP_PAN = 'ddc.map.pan';

function pan(map) {
	return {
		eventType: DDC_MAP_PAN,
		eventData: {
			// the map's container element, so pushEvent enrichment can
			// resolve the widget (widgetName/widgetHeading) it lives in
			element: map?.getDiv?.()
		}
	};
}

export default pan;
